import { FilterNodeDataSchema } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type { WorkflowNodeHydration } from '../workflow-node-base';
import type { WorkflowNodeOutputShapeContext } from '../workflow-node-output-shape';
import { TypedWorkflowNode } from './typed-workflow-node';

/**
 * A filter node gates execution: it evaluates a condition against its upstream
 * output and either passes the value through (continue) or halts the branch
 * (stop). Since the runtime passes the input through unchanged, its output shape
 * mirrors its single predecessor's so downstream editors keep their field
 * suggestions.
 */
export class FilterWorkflowNode extends TypedWorkflowNode<
  typeof FilterNodeDataSchema
> {
  protected readonly schema = FilterNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): FilterWorkflowNode {
    return new FilterWorkflowNode(data, hydration);
  }
  override deriveTypedOutputShape(
    context: WorkflowNodeOutputShapeContext
  ): string | null {
    return context.resolvePredecessorOutputShape?.(this.id) ?? null;
  }
}
